import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchManagedUpgradeContent: DocumentNode = gql`
  query FetchManagedUpgradeContent($storyId: String!, $version: String!, $relations: String) {
    fetchManagedContent: fetchManagedUpgradeContent(storyId: $storyId, version: $version, relations: $relations) {
      ... on ManagedUpgradeContent {
        cv
        story {
          slug
          content {
            component
            contentSections
            ctaText
            headerImage
            headerTitle
          }
        }
        rels
      }
    }
  }
`

export default fetchManagedUpgradeContent
